import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "unexpected-event-and-alert-statuse-list" }
const _hoisted_2 = {
  key: 0,
  class: "not-searched"
}
const _hoisted_3 = {
  key: 1,
  class: "not-searched"
}
const _hoisted_4 = { class: "table-scrollbar" }
const _hoisted_5 = { class: "table-header-row" }
const _hoisted_6 = { class: "pl-0" }
const _hoisted_7 = { class: "d-flex flex-row" }
const _hoisted_8 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_9 = { class: "d-flex ml-2" }
const _hoisted_10 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_11 = { class: "column-space" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { colspan: "9" }

import unexpectedEventsAndLongTimeContinuousDrivingExtensions from "src/types/responses/unexpectedEventsAndLongTimeContinuousDrivingExtensions";
import ResizableList from '@/components/ResizableList.vue';
import EditOrDeleteButtons from "@/components/UnexpectedEventAndAlertStatuseList/EditOrDeleteButtons.vue"
import { formatDateTime, formatDate } from "@/services/functions";
import getAccountResponse from "@/types/responses/getAccount";
import CopyElement from "@/components/CopyElement.vue";
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'UnexpectedEventAndAlertStatuseList',
  props: {
    unexpectedEventAndAlertStatuse: {},
    searched: { type: Boolean },
    isOperationOffice: { type: Boolean },
    isDepartment: { type: Boolean },
    accounts: {},
    isLoading: { type: Boolean },
    deleteAuthority: { type: Boolean },
    openUnexpectedModal: { type: Function },
    openDeleteConfirmModal: { type: Function }
  },
  setup(__props: any) {

const props = __props

const HEADER = ([
  i18n.global.t('pages.unexpectedEventAndAlertStatuses.listHeader.tripId'),
  i18n.global.t('pages.unexpectedEventAndAlertStatuses.listHeader.division'),
  i18n.global.t('pages.unexpectedEventAndAlertStatuses.listHeader.startTime'),
  i18n.global.t('pages.unexpectedEventAndAlertStatuses.listHeader.endTime'),
  i18n.global.t('pages.unexpectedEventAndAlertStatuses.listHeader.numberPlate'),
  i18n.global.t('pages.unexpectedEventAndAlertStatuses.listHeader.driverName'),
  i18n.global.t('pages.unexpectedEventAndAlertStatuses.listHeader.edit'),
  i18n.global.t('pages.unexpectedEventAndAlertStatuses.listHeader.updatedByAndDate')
])

const makeDivision = computed(() => (division: string) => {
  if (division == 'unexpected_events') return i18n.global.t('pages.unexpectedEventAndAlertStatuses.unexpectedEvents')
  if (division == 'long_time_continuous_driving_extensions') return i18n.global.t('pages.unexpectedEventAndAlertStatuses.longTimeContinuousDriving')
  return ''
})

const updatedBy = computed(() => (item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) => {
  return props.accounts.find((account: getAccountResponse) => {
    return account.id == item.updated_by
  })
})

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.searched && !props.isOperationOffice && !props.isDepartment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.runFilter')), 1)
        ]))
      : _createCommentVNode("", true),
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(ResizableList, { scrollAreaSelector: ".v-table__wrapper" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_5, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(HEADER, (item, index) => {
                    return _createElementVNode("th", { key: item }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(index === 0 ? 'ml-2' : '')
                      }, _toDisplayString(item), 3)
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (props.unexpectedEventAndAlertStatuse?.length != 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.unexpectedEventAndAlertStatuse, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(item.delivery_plan_id.substr(-7, 7)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(CopyElement, {
                                copyText: item.delivery_plan_id,
                                size: "small"
                              }, null, 8, ["copyText"])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(makeDivision.value(item.division_name)), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(formatDateTime)(new Date(item.start_time))), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(formatDateTime)(new Date(item.end_time))), 1),
                        _createElementVNode("td", null, _toDisplayString(item.car_number), 1),
                        _createElementVNode("td", null, _toDisplayString(item.driver_name), 1),
                        _createElementVNode("td", null, [
                          _createVNode(EditOrDeleteButtons, {
                            item: item,
                            deleteAuthority: props.deleteAuthority,
                            openUnexpectedModal: props.openUnexpectedModal,
                            openDeleteConfirmModal: props.openDeleteConfirmModal
                          }, null, 8, ["item", "deleteAuthority", "openUnexpectedModal", "openDeleteConfirmModal"])
                        ]),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(updatedBy.value(item)?.name) + "/" + _toDisplayString(_unref(formatDate)(new Date(item.updated_at))), 1)
                      ]))
                    }), 128))
                  : (props.searched && !props.isLoading)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.common.list.noData')), 1)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})